import React, { useState, useEffect } from "react"
import { Row, Col, Button, TabContent, TabPane, Label } from "reactstrap"
import DPTextBoxforgrid from "framework/components/DPTextBoxforgrid";
import { GetAllTxn, LoadBeforeSaveLedgerDetails, getAllCostCenters, getLedgerDetails } from "./LedgerController";
import ReactPaginate from "react-paginate";
import DPSwitch from "framework/components/DPSwitch";
import { Context } from "app-contexts/CommonContexts"
import { useContext } from "react"
import DPNavBar from "framework/widgets/DPNavBar";
import { LedgerDetail } from "./LedgerDetail";
import { LedgerSummary } from "./LedgerSummary";


const LedgerFilterations = ({
    selectedCheckbox,
    setSelectedCheckbox,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    selectedLocation,
    setSelectedLocation,
    selectedTransaction,
    setSelectedTransaction,
    handleChange,
    SetLoadingAlerttitle,
    SetLoadingAlert,
    setShow,
    setAlertMsg,
    setAlertColor,
    Time,
    setSaveEnable,
    setDocumentList,
    documentList,
    diableElements,
    setDiableElements,
    setCreditDebitDiffence,
    credit_debit_diffence

}) => {

    const {
        txnDecimalAmt
    } = useContext(Context);

    const [txnSearch, setTxnSearch] = useState('');
    const [txnList, setTxnList] = useState([]);
    const [txnPage, setTxnPage] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(5)

    const [locationPage, setLocationPage] = useState(1)
    const [locationList, setLocationList] = useState([])
    const [locationSearch, setLocationSearch] = useState('')
    const [locationSearchBy, setLocationSearchBy] = useState('code')

    const [documentPage, setDocumentPage] = useState(1)
    const [documentSearch, setDocumentSearch] = useState('')
    const [documentSearchBy, setDocumentSearchBy] = useState('documentNo')
    const [documentSearchByName, setDocumentSearchByName] = useState('DocumentNo')
    const [sortBy, setSortBy] = useState('')


    const [ledgerUpdationPage, setLedgerUpdationPage] = useState(1)
    const [ledgerSummaryPage, setLedgerSummaryPage] = useState(1)
    const [ledgerUpdationList, setLedgerUpdationList] = useState([])

    const [customActiveTab, setcustomActiveTab] = useState("1")
    const [tabList, SetTabList] = useState([
        {
            text: "Detail",
            icon: "fas fa-home",
            tabID: "1",
            onClick: () => {
                toggleCustom("1")
            },
        },
        {
            text: "Summary",
            icon: "far fa-user",
            tabID: "2",
            onClick: () => {
                toggleCustom("2")
            },
        }])

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [txnData, locationData] = await Promise.all([GetAllTxn(), getAllCostCenters()]);
                setTxnList(txnData);
                setLocationList(locationData);
            } catch (error) {
                // Handle error here
                console.log(error);
            }
        };

        fetchData();
    }, []);

    useEffect(() => {
        setTxnSearch('')
        setTxnPage(1)
        setLocationPage(1)
        setLocationSearch('')
        setLocationSearchBy('code')
        setDocumentPage(1)
        setDocumentSearch('')
        setDocumentSearchBy('documentNo')
        setDocumentSearchByName('DocumentNo')
        setDocumentList([])
        setLedgerUpdationList([])
        setSortBy('')
        setLedgerUpdationPage(1)
        setLedgerSummaryPage(1)
        setcustomActiveTab("1")
    }, [handleChange])



    const handleCheckboxChange = (event) => {
        setSelectedCheckbox(event.target.value);
        setStartDate('');
        setEndDate('');
    };

    const handleStartDateChange = (event) => {
        setStartDate(event.target.value);
    };

    const handleEndDateChange = (event) => {
        setEndDate(event.target.value);
    };

    const handleTxnPageClick = (event) => {
        setTxnPage(event.selected + 1);
    };

    const handleLocationPageClick = (event) => {
        setLocationPage(event.selected + 1);
    };

    const handleDocumentPageClick = (event) => {
        setDocumentPage(event.selected + 1);
    };

    const handleLedgerUpdationPageClick = (event) => {
        setLedgerUpdationPage(event.selected + 1);
    };

    const handleLedgerSummaryPageClick = (event) => {
        setLedgerSummaryPage(event.selected + 1);
    };

    /*---------------------------------  Txn  ---------------------------------------------------------------------- */
    const txnFilterData = txnList.filter((item) => {
        if (txnSearch == null)
            return item
        else if (item.description.toLowerCase().includes(txnSearch.toLowerCase())) {
            return item
        }
    })

    const indexOfLastPostTxn = txnPage * rowsPerPage
    const indexOfFirstPostTxn = indexOfLastPostTxn - rowsPerPage
    const currentDetailRowsTxn = txnFilterData.slice(indexOfFirstPostTxn, indexOfLastPostTxn)

    /*---------------------------------  Location ---------------------------------------------------------------------- */
    const locationFilterData = locationList.filter((item) => {
        if (locationSearch == null)
            return item
        else if (item[locationSearchBy].toLowerCase().includes(locationSearch.toLowerCase())) {
            return item
        }
    })

    const indexOfLastPostLocation = locationPage * rowsPerPage
    const indexOfFirstPostLocation = indexOfLastPostLocation - rowsPerPage
    const currentDetailRowsLocation = locationFilterData.slice(indexOfFirstPostLocation, indexOfLastPostLocation)

    /*---------------------------------  Document ---------------------------------------------------------------------- */
    const documentFilterData = documentList.filter((item) => {
        if (documentSearch == null)
            return item
        else if (item[documentSearchBy].toLowerCase().includes(documentSearch.toLowerCase())) {
            return item
        }
    })

    //sort ledgerUpdationList by given field and order

    const sortedLedgerUpdationList = ledgerUpdationList.sort((a, b) => {
        if (sortBy == 'date') {
            return a.date - b.date;
        } else if (sortBy == 'doucmentNo') {
            return a.doucmentNo - b.doucmentNo;
        }
        return 0;
    });

    const indexOfLastPostDocument = documentPage * rowsPerPage
    const indexOfFirstPostDocument = indexOfLastPostDocument - rowsPerPage
    const currentDetailRowsDocument = documentFilterData.slice(indexOfFirstPostDocument, indexOfLastPostDocument)

    const handleSwitchChanges = (e, values, index) => {
        const change = values;
        change.isSelect = e

        var newStoles = [];

        for (var i = 0; i < documentList.length; i++) {
            if (documentList[i].documentNo == change.documentNo) {
                newStoles.push(change);
            } else {
                newStoles.push(documentList[i]);
            }
        }
        setDocumentList(newStoles);
    }

    //handle all switches 
    const handleAllSwitchChanges = (e) => {

        const change = [...documentList];
        change.map((item, index) => {
            item.isSelect = e
        })
        setDocumentList(change)

    }

    async function GetLedgerDetailsOnClick() {

        if (selectedLocation == '') {
            setShow(true)
            setAlertMsg('Please Select Location!')
            setAlertColor('danger')
            setTimeout(() => {
                setShow(false)
            }, Time);
            return
        }

        if (selectedTransaction == '') {
            setShow(true)
            setAlertMsg('Please Select Transaction!')
            setAlertColor('danger')
            setTimeout(() => {
                setShow(false)
            }, Time);
            return
        }


        var searchLedger = {
            "locations": selectedLocation,
            "transactions": selectedTransaction,
            "dateSelection": parseInt(selectedCheckbox),
            "fromDate": startDate ? startDate : "1900-01-01",
            "toDate": endDate ? endDate : "1900-01-01",
            "asAtDate": startDate ? startDate : "1900-01-01",
        }
        SetLoadingAlerttitle('Getting Ledger Details...')
        SetLoadingAlert(true)
        const resultData = await getLedgerDetails(searchLedger)
        SetLoadingAlert(false)

        if (resultData.length == 0) {
            setAlertColor('danger')
            setAlertMsg('No Data Found!')
            setShow(true)
            setTimeout(() => {
                setShow(false)
            }, Time);
        } else {
            setDocumentList(resultData)
        }
    }


    async function SaveLedgerDetailsOnClick() {
        setSortBy('')
        setLedgerUpdationPage(1)
        setLedgerSummaryPage(1)
        var ledgerSelectedDocs = []

        documentList.filter((item) => {
            if (item.isSelect == true) {
                ledgerSelectedDocs.push({
                    "DOC_NO": item.documentNo,
                    "LOC_CODE": selectedLocation,
                })
            }
        })

        if (ledgerSelectedDocs.length == 0) {
            setShow(true)
            setAlertMsg('Please Select atleast one document!')
            setAlertColor('danger')
            setTimeout(() => {
                setShow(false)
            }, Time);
            return
        }

        SetLoadingAlerttitle('Generating Details...')
        SetLoadingAlert(true)
        var updatedDetails = await LoadBeforeSaveLedgerDetails(selectedTransaction, selectedLocation, ledgerSelectedDocs)
        SetLoadingAlert(false)
        if (updatedDetails.length > 0) {
            setLedgerUpdationList(updatedDetails)

            const credit_sum = updatedDetails.reduce((a, b) => +a + +(b.credit), 0)
            const debit_sum = updatedDetails.reduce((a, b) => +a + +(b.debit), 0)

            setCreditDebitDiffence(Math.abs(Math.abs(debit_sum) - Math.abs(credit_sum)))

            setSaveEnable(true)
            setDiableElements(true)
        }

    }

    const toggleCustom = tab => {
        setcustomActiveTab(tab)
    }


    return (
        <React.Fragment>
            <Row>
                <Col sm={12} md={5} className="mb-4-sm">
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ marginRight: '16px', flexGrow: 1 }}>
                            <input
                                type="checkbox"
                                id="checkbox1"
                                name="checkbox"
                                value="2"
                                checked={selectedCheckbox === '2'}
                                onChange={handleCheckboxChange}
                                className="form-check-input"
                                disabled={diableElements}
                            />
                            <label htmlFor="checkbox1" className="form-check-label mx-2">Date As At</label>

                        </div>

                        <div style={{ marginRight: '16px', flexGrow: 1 }}>
                            <input
                                type="checkbox"
                                id="checkbox2"
                                name="checkbox"
                                value="1"
                                checked={selectedCheckbox === '1'}
                                onChange={handleCheckboxChange}
                                className="form-check-input"
                                disabled={diableElements}
                            />
                            <label htmlFor="checkbox2" className="form-check-label mx-2">Date Range</label>

                        </div>

                        <div style={{ flexGrow: 1 }}>
                            <input
                                type="checkbox"
                                id="checkbox3"
                                name="checkbox"
                                value="0"
                                checked={selectedCheckbox === '0'}
                                onChange={handleCheckboxChange}
                                className="form-check-input"
                                disabled={diableElements}
                            />
                            <label htmlFor="checkbox3" className="form-check-label mx-2">All</label>
                        </div>
                    </div>
                    <Row className="mt-2">
                        {selectedCheckbox === '2' && (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <DPTextBoxforgrid textType="date" value={startDate} onChange={handleStartDateChange} disabled={diableElements} />
                            </div>
                        )}
                        {selectedCheckbox === '1' && (
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <DPTextBoxforgrid textType="date" value={startDate} onChange={handleStartDateChange} disabled={diableElements} />
                                <label htmlFor="checkbox1" className="form-check-label mx-2">To</label>
                                <DPTextBoxforgrid textType="date" value={endDate} onChange={handleEndDateChange} disabled={diableElements} />
                            </div>
                        )}
                    </Row>

                </Col>
                <Col sm={12} md={3} className="mb-4-sm">
                    <Row>

                    </Row>
                </Col>
                <Col sm={12} md={4} className="mb-4-sm">

                </Col>
            </Row>
            <Row className="mt-2">
                <Col sm={12} md={5} className="mb-4-sm">
                    <Row>
                        <Col sm={12} md={6} className="mb-4-sm px-0">
                            <Row style={{ height: '300px' }}>
                                <Col>
                                    <table className="custom-table table-bordered table-sm rounded" >
                                        <thead className='table-secondary'>
                                            <tr>
                                                <th colSpan={2}>
                                                    <DPTextBoxforgrid
                                                        placeholder={locationSearchBy == 'code' ? "Location Search By Code..." : "Location Search By Name..."}
                                                        value={locationSearch}
                                                        onChange={(e) => {
                                                            setLocationSearch(e.target.value)
                                                        }}
                                                        id={'location'}
                                                        disabled={diableElements}
                                                    /></th>
                                            </tr>
                                            <tr style={{ height: '40px' }}>
                                                <td onClick={() => {
                                                    setLocationSearchBy('code')
                                                    document.getElementById('location').focus()
                                                }}
                                                    style={{ cursor: 'pointer', fontWeight: 'bold' }}
                                                >
                                                    Code
                                                </td>
                                                <td onClick={() => {
                                                    setLocationSearchBy('name')
                                                    document.getElementById('location').focus()
                                                }}
                                                    style={{ cursor: 'pointer', fontWeight: 'bold' }}
                                                >
                                                    Description
                                                </td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {currentDetailRowsLocation.map((item, index) => (
                                                <tr
                                                    key={index} onClick={() => {
                                                        if (!diableElements) {
                                                            setSelectedLocation(item.code)
                                                            setDocumentList([])
                                                            setDocumentPage(1)
                                                        }
                                                    }}
                                                    style={{ background: selectedLocation == item.code ? '#B4B8BD' : '', maxHeight: '40px', textAlign: 'start' }}
                                                >
                                                    <td>{item.code}</td>
                                                    <td >
                                                        {item.name}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </Col>
                            </Row>


                            <ReactPaginate
                                previousLabel={'Previous'}
                                nextLabel={'Next'}
                                breakLabel={'...'}
                                pageClassName="page-item"
                                pageLinkClassName="page-link"
                                previousClassName="page-item"
                                previousLinkClassName="page-link"
                                nextClassName="page-item"
                                nextLinkClassName="page-link"
                                breakClassName="page-item"
                                breakLinkClassName="page-link"
                                pageCount={Math.ceil(locationFilterData.length / rowsPerPage)}
                                pageRangeDisplayed={1}
                                onPageChange={handleLocationPageClick}
                                forcePage={locationPage - 1}
                                renderOnZeroPageCount={null}
                                activeClassName={'active'}
                                activeLinkClassName={'page-link'}
                                containerClassName={'pagination justify-content-end pagination-sm'}
                                marginPagesDisplayed={1}
                            />
                        </Col>

                        <Col sm={12} md={6} className="mb-4-sm px-0">
                            <Row style={{ height: '300px' }}>
                                <Col>
                                    <table className="custom-table table-bordered table-sm rounded">
                                        <thead className='table-secondary'>
                                            <tr>
                                                <th>
                                                    <DPTextBoxforgrid
                                                        placeholder={"Transaction Search..."}
                                                        value={txnSearch}
                                                        onChange={(e) => {
                                                            setTxnSearch(e.target.value)
                                                        }}
                                                        disabled={diableElements}
                                                    /></th>
                                            </tr>
                                            <tr style={{ height: '40px' }}>
                                                <td style={{ cursor: 'pointer', fontWeight: 'bold' }}>
                                                    Transaction
                                                </td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {currentDetailRowsTxn.map((item, index) => (
                                                <tr key={index} onClick={() => {
                                                    if (!diableElements) {
                                                        setSelectedTransaction(item.type)
                                                        setDocumentList([])
                                                        setDocumentPage(1)
                                                    }
                                                }}
                                                    style={{ background: selectedTransaction == item.type ? '#B4B8BD' : '' }}
                                                >
                                                    <td>
                                                        {item.description}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </Col>
                            </Row>

                            <ReactPaginate
                                previousLabel={'Previous'}
                                nextLabel={'Next'}
                                breakLabel={'...'}
                                pageClassName="page-item"
                                pageLinkClassName="page-link"
                                previousClassName="page-item"
                                previousLinkClassName="page-link"
                                nextClassName="page-item"
                                nextLinkClassName="page-link"
                                breakClassName="page-item"
                                breakLinkClassName="page-link"
                                pageCount={Math.ceil(txnFilterData.length / rowsPerPage)}
                                pageRangeDisplayed={1}
                                onPageChange={handleTxnPageClick}
                                forcePage={txnPage - 1}
                                renderOnZeroPageCount={null}
                                activeClassName={'active'}
                                activeLinkClassName={'page-link'}
                                containerClassName={'pagination justify-content-end pagination-sm'}
                                marginPagesDisplayed={1}


                            />
                        </Col>
                    </Row>
                </Col>
                <Col sm={12} md={1} className="mb-4-sm px-0">
                    <Row>
                        <Col className="text-center mb-2 mx-1">
                            <Button
                                color="primary"
                                onClick={GetLedgerDetailsOnClick}
                                disabled={diableElements}
                            >
                                GET DETAILS
                            </Button>
                        </Col>
                    </Row>
                </Col>
                <Col sm={12} md={6} className="mb-4-sm px-0">
                    <Row>
                        <Col sm={12} md={12} className="mb-4-sm">
                            <Row style={{ height: '300px' }}>
                                <Col>
                                    <table className="custom-table table-bordered table-sm rounded">
                                        <thead className='table-secondary'>
                                            <tr>
                                                <th colSpan={5}>
                                                    <DPTextBoxforgrid
                                                        placeholder={`Transaction Search By ${documentSearchByName}...`}
                                                        value={documentSearch}
                                                        onChange={(e) => {
                                                            setDocumentSearch(e.target.value)
                                                        }}
                                                        id={'documentSearch'}
                                                        disabled={diableElements}
                                                    /></th>
                                            </tr>
                                            <tr style={{ height: '40px' }}>
                                                <td onClick={() => {
                                                    setDocumentSearchBy('documentNo')
                                                    setDocumentSearchByName('DocumentNo')
                                                    document.getElementById('documentSearch').focus()
                                                }}
                                                    style={{ cursor: 'pointer', fontWeight: 'bold' }}
                                                >Document#</td>
                                                <td onClick={() => {
                                                    setDocumentSearchBy('date')
                                                    setDocumentSearchByName('Date')
                                                    document.getElementById('documentSearch').focus()
                                                }}
                                                    style={{ cursor: 'pointer', fontWeight: 'bold' }}
                                                >Date</td>
                                                <td onClick={() => {
                                                    setDocumentSearchBy('netAmount')
                                                    setDocumentSearchByName('Net Amount')
                                                    document.getElementById('documentSearch').focus()
                                                }}
                                                    style={{ textAlign: 'right', cursor: 'pointer', fontWeight: 'bold' }}
                                                >Net Amount</td>
                                                <td onClick={() => {
                                                    setDocumentSearchBy('referenceNo')
                                                    setDocumentSearchByName('Reference')
                                                    document.getElementById('documentSearch').focus()
                                                }}
                                                    style={{ cursor: 'pointer', fontWeight: 'bold' }}
                                                >Reference #</td>
                                                <td scope="col" style={{ width: '60px' }}><DPSwitch
                                                    checked={documentList.length > 0 ? documentList.every((values) => values.isSelect === true) : false}
                                                    onChange={(e) => {
                                                        handleAllSwitchChanges(e)
                                                    }}
                                                    disabled={diableElements}
                                                /></td>
                                            </tr>
                                        </thead>
                                        <tbody >
                                            {currentDetailRowsDocument.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{item.documentNo}</td>
                                                    <td>{item.date.slice(0, 10)}</td>
                                                    <td style={{ textAlign: 'right' }}>{parseFloat(item.netAmount).toFixed(txnDecimalAmt)}</td>
                                                    <td>{item.referenceNo}</td>
                                                    <td>
                                                        <DPSwitch
                                                            checked={item.isSelect}
                                                            onChange={(e) => {
                                                                handleSwitchChanges(e, item, index)
                                                            }}
                                                            disabled={diableElements}
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </Col>
                            </Row>

                            <ReactPaginate
                                previousLabel={'Previous'}
                                nextLabel={'Next'}
                                breakLabel={'...'}
                                pageClassName="page-item"
                                pageLinkClassName="page-link"
                                previousClassName="page-item"
                                previousLinkClassName="page-link"
                                nextClassName="page-item"
                                nextLinkClassName="page-link"
                                breakClassName="page-item"
                                breakLinkClassName="page-link"
                                pageCount={Math.ceil(documentFilterData.length / rowsPerPage)}
                                pageRangeDisplayed={1}
                                onPageChange={handleDocumentPageClick}
                                forcePage={documentPage - 1}
                                renderOnZeroPageCount={null}
                                activeClassName={'active'}
                                activeLinkClassName={'page-link'}
                                containerClassName={'pagination justify-content-end pagination-sm'}
                                marginPagesDisplayed={1}

                            />
                        </Col>
                    </Row>
                </Col>

            </Row>

            <Row>

                <Label htmlFor="example-text-input" className={`col-md-3 col-form-label-sm`} style={{ fontWeight: 'bold' }}>
                    Credit Debit Difference : {Math.abs(credit_debit_diffence).toLocaleString(undefined, {
                        maximumFractionDigits: txnDecimalAmt,
                        minimumFractionDigits: 2,
                    })}
                </Label>

            </Row>


            <Row>
                <Col className="text-center mb-2">
                    <Button
                        color="primary"
                        onClick={SaveLedgerDetailsOnClick}
                    >
                        Generate Ledger
                    </Button>
                </Col>

            </Row>

            <Row>
                <DPNavBar buttons={tabList} activeStatus={customActiveTab} />

                <TabContent activeTab={customActiveTab} className="p-3 text">
                    <TabPane tabId="1">
                        <LedgerDetail
                            handleLedgerUpdationPageClick={handleLedgerUpdationPageClick}
                            ledgerUpdationList={ledgerUpdationList}
                            ledgerUpdationPage={ledgerUpdationPage}
                            sortedLedgerUpdationList={sortedLedgerUpdationList}
                        />
                    </TabPane>
                    <TabPane tabId="2">
                        <LedgerSummary
                            handleLedgerSummaryPageClick={handleLedgerSummaryPageClick}
                            ledgerUpdationList={ledgerUpdationList}
                            ledgerSummaryPage={ledgerSummaryPage}
                            sortedLedgerUpdationList={sortedLedgerUpdationList}
                        />
                    </TabPane>
                </TabContent>



            </Row>

        </React.Fragment >
    )


}

export default LedgerFilterations;